/**
 * Design system — unified visual language for the Formency learner experience.
 *
 * Tabbed reference showing foundations, components, patterns, and usage rules.
 * Each tab lives in its own file under designsystem/tabs/.
 */
import { Tabs } from '@/interfaces/learner/ui';
import FoundationsTab from './tabs/FoundationsTab';
import ControlsTab from './tabs/ControlsTab';
import SurfacesTab from './tabs/SurfacesTab';
import ProgressTab from './tabs/ProgressTab';
import ListsTab from './tabs/ListsTab';
import StatesTab from './tabs/StatesTab';
import UsageTab from './tabs/UsageTab';
import CardGridTab from './tabs/CardGridTab';
import IllustrationsTab from './tabs/IllustrationsTab';

export default function DesignSystemPage() {
  return (
    <div
      className="relative mx-auto w-full px-6 pb-24"
      style={{ fontFamily: 'var(--font-sans)', maxWidth: 'var(--page-max-width)' }}
    >
      {/* Page header */}
      <section className="relative pt-14 pb-8">
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 28,
            fontWeight: 700,
            color: 'var(--color-text)',
            letterSpacing: '-0.025em',
            lineHeight: 1.2,
            marginBottom: 8,
          }}
        >
          Design System
        </h1>
        <p
          style={{
            fontSize: 15,
            fontWeight: 400,
            color: 'var(--color-text-secondary)',
            lineHeight: 1.55,
          }}
        >
          Unified visual language for the Formency learner experience.
        </p>
      </section>

      {/* Tab navigation */}
      <div className="relative mb-10">
        <Tabs
          tabs={[
            { id: 'foundations', label: 'Foundations', content: <FoundationsTab /> },
            { id: 'controls', label: 'Controls', content: <ControlsTab /> },
            { id: 'surfaces', label: 'Surfaces & Cards', content: <SurfacesTab /> },
            { id: 'progress', label: 'Progress & Data', content: <ProgressTab /> },
            { id: 'lists', label: 'Lists & Empty States', content: <ListsTab /> },
            { id: 'states', label: 'States & Motion', content: <StatesTab /> },
            { id: 'card-grid', label: 'Card Grid', content: <CardGridTab /> },
            { id: 'illustrations', label: 'Illustrations', content: <IllustrationsTab /> },
            { id: 'usage', label: 'Usage Rules', content: <UsageTab /> },
          ]}
        />
      </div>
    </div>
  );
}
